import { call, put, takeLatest, select } from 'redux-saga/effects';
import {
  FETCH_COURSES_INIT,
  FETCH_COURSES_SUCCESS,
  FETCH_COURSES_FAILED,
  COURSE_COMPLETE_LESSON,
  ADD_POST_INIT,
  ADD_POST_SUCCESS,
  ADD_POST_FAILED,
  FETCH_FORUM_FAILED,
  FETCH_FORUM_SUCCESS,
  FETCH_FORUM_INIT,
  FETCH_TERMS_INIT,
  FETCH_TERMS_SUCCESS,
  FETCH_TERMS_FAILED,
} from '../actionTypes';
import { getCurriculumCourses } from '../../service/content';
import { getTerms } from '../../service/glossary';
import { addPost as addPostRequest, getForum } from '../../service/forum';
import { updateUserProgress as updateUserProgressRequest } from '../../service/user';
import {
  makeSelectCurrentCourse,
  makeSelectCurrentLesson,
  makeSelectUserId,
} from '../selectors';

function* fetchCourses({ payload: { curriculumId } }) {
  try {
    const res = yield call(getCurriculumCourses, curriculumId);

    if (res.data && res.data.data) {
      yield put({ type: FETCH_COURSES_SUCCESS, payload: res.data.data });
    }
  } catch (error) {
    yield put({ type: FETCH_COURSES_FAILED, error });
  }
}

function* fetchTerms() {
  try {
    const res = yield call(getTerms);

    if (res.data && res.data.data) {
      yield put({ type: FETCH_TERMS_SUCCESS, terms: res.data.data });
    }
  } catch (error) {
    yield put({ type: FETCH_TERMS_FAILED, error });
  }
}

function* updateUserProgress({ isComplete }) {
  try {
    const userId = yield select(makeSelectUserId());
    const currentCourse = yield select(makeSelectCurrentCourse());
    const currentLesson = yield select(makeSelectCurrentLesson());

    yield call(updateUserProgressRequest, userId, {
      courseId: currentCourse._id,
      lessonId: currentLesson._id,
      isComplete,
    });
  } catch (error) {
    console.log('Error in updating user progress', error);
  }
}

function* addPost({ payload: { cb, ...rest } }) {
  try {
    const res = yield call(addPostRequest, rest);

    yield put({ type: ADD_POST_SUCCESS, payload: res.data.data });
    if (typeof cb === 'function') {
      cb();
    }
  } catch (error) {
    console.log('[addpost.error]', error);
    yield put({ type: ADD_POST_FAILED });
  }
}

function* fetchForum({ payload: { forumId, query } }) {
  try {
    console.log('[fetchforum.saga.param]', forumId, query);
    const res = yield call(getForum, forumId, query);
    yield put({ type: FETCH_FORUM_SUCCESS, payload: res.data.data });
  } catch (err) {
    console.log('[fetchforum.error]', err);
    yield put({ type: FETCH_FORUM_FAILED });
  }
}

export function* watchCourse() {
  yield takeLatest(FETCH_COURSES_INIT, fetchCourses);
  yield takeLatest(COURSE_COMPLETE_LESSON, updateUserProgress);
  yield takeLatest(ADD_POST_INIT, addPost);
  yield takeLatest(FETCH_FORUM_INIT, fetchForum);
  yield takeLatest(FETCH_TERMS_INIT, fetchTerms);
}
